/**
 * Select panel — a compact, searchable checkbox list.
 *
 * Used wherever a form offers many options (RBAC roles, group membership,
 * bulk default-role assignment). Each panel is self-contained and marked with
 * data-select-panel, so this initialiser is a no-op on pages without one.
 */

function initPanel(panel) {
    const search = panel.querySelector('[data-select-panel-search]');
    const counter = panel.querySelector('[data-select-panel-count]');
    const empty = panel.querySelector('[data-select-panel-empty]');
    const options = Array.from(panel.querySelectorAll('[data-select-panel-option]'));

    function updateCount() {
        if (!counter) return;
        const selected = options.filter((o) => {
            const input = o.querySelector('input');
            return input && input.checked;
        }).length;
        counter.textContent = `${selected} / ${options.length}`;
    }

    function applyFilter() {
        const term = (search ? search.value : '').trim().toLowerCase();
        let visible = 0;
        options.forEach((o) => {
            const name = (o.getAttribute('data-name') || '').toLowerCase();
            const match = term === '' || name.includes(term);
            o.style.display = match ? '' : 'none';
            if (match) visible++;
        });
        if (empty) empty.style.display = visible === 0 ? '' : 'none';
    }

    if (search) search.addEventListener('input', applyFilter);
    panel.addEventListener('change', updateCount);
    updateCount();
}

export function initSelectPanels(root = document) {
    root.querySelectorAll('[data-select-panel]').forEach(initPanel);
}

/**
 * Checks or clears every option of the panel nearest the given button.
 * Only the rows currently passing the search filter are touched, so narrowing
 * the list and hitting "select all" selects exactly what is on screen.
 */
export function toggleAllSelectPanel(button) {
    const scope = button.closest('form') || document;
    const panel = scope.querySelector('[data-select-panel]');
    if (!panel) return;

    const options = Array.from(panel.querySelectorAll('[data-select-panel-option]'))
        .filter((o) => o.style.display !== 'none');
    const inputs = options.map((o) => o.querySelector('input')).filter(Boolean);
    const check = inputs.some((i) => !i.checked);

    inputs.forEach((i) => { i.checked = check; });
    panel.dispatchEvent(new Event('change', { bubbles: true }));

    const label = check
        ? button.getAttribute('data-clear-label')
        : button.getAttribute('data-select-all-label');
    if (label) button.textContent = label;
}

window.toggleAllSelectPanel = toggleAllSelectPanel;
